import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles({
  tableRow: {
    '&:hover': {
      background: '#ebebeb',
      cursor: 'pointer',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
  },
  chip: {
    marginLeft: 5,
  },
  hoverButton: {
    '&hover': {
      backgroundColor: 'grey',
    },
  },
});
